// The AXOS dashboard's card layout: which cards are shown, in what order, and how many fit in a row. It is kept per
// workspace in this browser, so a reload keeps it. Storage can be blocked, emptied or hold an old layout naming a card
// that no longer exists; every read falls back to the defaults and every write is allowed to fail quietly.

export const LAYOUT_KEY_PREFIX = "growthos.axos-dashboard-layout.v1:";
const COLUMNS = [3, 4, 5];

/** The saved layout for this workspace, keeping only known cards once each; the defaults when there is none to use. */
export function readLayout(storage, clientSlug, knownIds, defaults) {
  try {
    const saved = JSON.parse(storage?.getItem(LAYOUT_KEY_PREFIX + clientSlug) ?? "null");
    if (!saved || !Array.isArray(saved.shown)) return defaults;
    const shown = [...new Set(saved.shown.filter((id) => knownIds.includes(id)))];
    return { shown, columns: COLUMNS.includes(saved.columns) ? saved.columns : defaults.columns };
  } catch {
    return defaults;
  }
}

export function writeLayout(storage, clientSlug, layout) {
  try { storage?.setItem(LAYOUT_KEY_PREFIX + clientSlug, JSON.stringify({ shown: layout.shown, columns: layout.columns })); } catch { /* the layout just is not kept */ }
}

export function clearLayout(storage, clientSlug) {
  try { storage?.removeItem(LAYOUT_KEY_PREFIX + clientSlug); } catch { /* nothing was kept */ }
}

/** Swap a shown card with its shown neighbour; the same list back when it cannot move. */
export function moveCard(shown, id, delta) {
  const index = shown.indexOf(id), target = index + delta;
  if (index < 0 || target < 0 || target >= shown.length) return shown;
  const next = [...shown];
  [next[index], next[target]] = [next[target], next[index]];
  return next;
}

/** Hide a shown card, or show a hidden one at the end. */
export function toggleCard(shown, id) {
  return shown.includes(id) ? shown.filter((key) => key !== id) : [...shown, id];
}
